// extracted by mini-css-extract-plugin
module.exports = {"subjectBreadcrumbs":"Hero_subjectBreadcrumbs__crkQJ","courseBreadcrumbs":"Hero_courseBreadcrumbs___Y0Pp","imageContainer":"Hero_imageContainer__W_qp3","image":"Hero_image__eT_1v"};